import {
    put, call, all, takeLatest, select
} from 'redux-saga/effects';
import { defaultSaga, getActions } from '../utils';

import * as constants from './constants';
import converter from './converter';
import * as api from './api';
import * as actions from './actions';

export default function* rootSaga() {
    yield all([
        yield takeLatest(
            constants.getDeterminantTypes.toString(),
            defaultSaga({
                constants: constants.getDeterminantTypes,
                after: converter.determinantTypes2Client,
                api: api.getDeterminantTypes
            })
        )
    ]);
}